import { render, staticRenderFns } from "./ListTipoRelatorioView.vue?vue&type=template&id=46a4b114&"
import script from "./ListTipoRelatorioView.vue?vue&type=script&lang=ts&"
export * from "./ListTipoRelatorioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports